/**
 * Conditional class names.
 *
 * The existing components join arrays inline; this is the same thing with falsy values dropped,
 * so `clsx('a', cond && 'b')` doesn't leave a stray `false` in the class attribute.
 */
export function clsx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
